import React, { useState, useEffect, useRef } from "react";

import {
  Col,
  Row,
  Divider,
  Input,
  Form,
  Button,
  Card,
  InputNumber,
  Checkbox,
  Modal,
  Select,
  message,
  Layout,
} from "antd";
import Cleave from "cleave.js/react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PosCommissionTable from "../routes/B2B/PosCommissionTable";
import PosSelectableInstallmentTable from "../routes/B2B/PosSelectableInstallmentTable";

import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "../routes/Forms/Helper";
import { ColumnHelper } from "util/TableHelper";
import { useHistory } from "react-router";
import { footerText } from "../util/config";
import Screen from "../util/Extensions/Screens";
import PosCollectionAmountSummary from "../routes/B2B/PosCollectionAmountSummary";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};
const { TextArea } = Input;
const ConstantPaymentPage = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [creditCardType, setCreditCardType] = useState("");
  const [form] = Form.useForm();
  const [email, setEmail] = useState("");
  const [paymentModal, setPaymentModal] = useState({
    visible: false,
    source: null,
  });
  const [availableProviders, setAvailableProviders] = useState({
    loading: true,
    data: [],
  });
  const [availableInstallments, setAvailableInstallments] = useState({
    loading: true,
    data: [1],
  });
  const [activeProviderId, setActiveProviderId] = useState();
  const [currencyCodes, setCurrencyCodes] = useState(["TRY", "USD", "EUR"]);
  const [commissionOptions, setCommissionOptions] = useState({
    loading: true,
    data: {
      useCommissionsForAvailableInstallment: false,
      useFirmGroupCodeForMaxInstallment: false,
      isSelectableInstallmentTable: false,
      posCollectionDescription: null,
      commissions: [],
    },
  });
  const [activeAmount, setActiveAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [radioValue, setRadioValue] = useState();
  const [tenantName, setTenantName] = useState("");
  const iframeRef = useRef();
  const [logoUrl, setLogoUrl] = useState();
  const [tenantPaymentGuid, setTenantPaymentGuid] = useState();
  const [isPaymentWithParams, setIsPaymentWithParams] = useState(false);
  const [disabledAmount, setDisabledAmount] = useState(false);

  const [firmId, setFirmId] = useState("");
  const [posCollectionTransactionId, setPosCollectionTransactionId] =
    useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [siteName, setSiteName] = useState("");
  const [paymentGuid, setPaymentGuid] = useState("");
  const { Footer } = Layout;

  const [confidentialAgreement, setconfidentialAgreement] = useState(
    "/gizlilik-ve-guvenlik-politikasi.pdf"
  );
  const [salesAgreement, setSalesAgreement] = useState("/tuketici-haklari.pdf");

  const [ozanIframe, setOzanIframe] = useState(false);
  const [useAdditionalInformation, setUseAdditionalInformation] =
    useState(false);

  const [isUseCreditCardBinCheck, setIsUseCreditCardBinCheck] = useState();
  const [usePosCommissionTable, setUsePosCommissionTable] = useState(false);
  const [
    commissionOptionsForBinCheckUsage,
    setCommissionOptionsForBinCheckUsage,
  ] = useState({
    loading: true,
    data: {
      useCommissionsForAvailableInstallment: false,
      useFirmGroupCodeForMaxInstallment: false,
      isSelectableInstallmentTable: false,
      posCollectionDescription: null,
      commissions: [],
    },
  });
  const [requestBin, setRequestBin] = useState(true);

  const [bankIdFromBinCheckResult, setBankIdFromBinCheckResult] =
    useState(null);
  const [cardKindFromBinCheckResult, setCardKindFromBinCheckResult] =
    useState(null);
  const [activeCommissionRate, setActiveCommissionRate] = useState(0.0);

  useEffect(() => {
    setPaymentGuid(props.location.search.split("d=")[1]);
    if (!activeProviderId) return;
    let currencies = ["TRY", "USD", "EUR"];

    //Param Pos || NKolay Pos
    if (activeProviderId === 889 || activeProviderId === 890) {
      currencies = ["TRY"];
    }

    setCurrencyCodes(currencies);
    setFieldsValue({ currencyCode: currencies[0] });

    if (!commissionOptions.data.isSelectableInstallmentTable) {
      getAvailableInstallments(activeProviderId);
    }
  }, [activeProviderId]);

  useEffect(() => {
    getConstantPaymentRequestInfo();
    setPaymentGuid(props.location.search.split("d=")[1]);
    getAvailableProviders(props.location.search.split("d=")[1]);
    getCommissionOptions(props.location.search.split("d=")[1]);
    if (props.data) {
      setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (commissionOptions.data.commissions.length > 0) {
      let bankIdFromBinCheck = bankIdFromBinCheckResult;
      const bankIdsFromCommissions = [
        ...new Set(
          commissionOptions.data.commissions.map((item) => item.bankId)
        ),
      ];
      RequestHandler.get(
        `/ConstantPaymentRequest/AvailableProviders?paymentGuid=${paymentGuid}${
          bankIdFromBinCheck ? "&bankIdFromBinCheck=" + bankIdFromBinCheck : ""
        }`
      ).then((response) => {
        if (response.success) {
          const filterWithCommissionBankIds = response.data.filter((x) =>
            bankIdsFromCommissions.includes(x.id)
          );
          setAvailableProviders({
            data: filterWithCommissionBankIds,
            loading: false,
          });
          setActiveProviderId(filterWithCommissionBankIds?.at(0)?.id);
          if (filterWithCommissionBankIds?.at(0)?.id) {
            getAvailableInstallments(
              filterWithCommissionBankIds?.at(0)?.id,
              commissionOptions.data.commissions
            );
          }
        } else {
          setAvailableProviders({ ...availableProviders, loading: false });
        }
      });
    }
  }, [commissionOptions]);

  const getAvailableProviders = (value) => {
    RequestHandler.get(
      `/ConstantPaymentRequest/AvailableProviders?paymentGuid=${value}`
    ).then((response) => {
      if (response.success) {
        setAvailableProviders({
          data: response.data,
          loading: false,
        });
        setActiveProviderId(response.data?.at(0)?.id);
      } else {
        setAvailableProviders({ ...availableProviders, loading: false });
      }
    });
  };

  const getCommissionOptions = (
    value,
    bankIdFromBinCheck,
    cardKindFromBinCheck,
    amount
  ) => {
    let queryString = `?paymentGuid=${value}`;

    if (amount !== null && amount !== undefined) {
      queryString += `${queryString ? "&" : "?"}amount=${amount}`;
    }

    if (bankIdFromBinCheck && firmId) {
      queryString += `&bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    } else if (bankIdFromBinCheck && queryString != "") {
      queryString += `&bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    } else if (bankIdFromBinCheck && queryString == "") {
      queryString += `?bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    }
    RequestHandler.get(
      `/ConstantPaymentRequest/CommissionOptions${queryString}`
    ).then((response) => {
      if (response.success) {
        setCommissionOptions({
          data: response.data,
          loading: false,
        });
      } else {
        setCommissionOptions({ ...commissionOptions, loading: false });
      }
    });
  };

  const getAvailableInstallments = (bankId, commissions) => {
    setAvailableInstallments({ ...availableInstallments, loading: true });

    RequestHandler.post(
      `/ConstantPaymentRequest/AvailableInstallments`,
      {
        bankId: bankId,
        paymentGuid: paymentGuid,
        commissions:
          commissions !== undefined && commissions !== null
            ? commissions.find((x) => x.bankId == bankId)
            : null,
        isUseCreditCardBinCheck: isUseCreditCardBinCheck,
      },
      false
    ).then((response) => {
      if (!response.success) {
        setAvailableInstallments({ ...availableInstallments, loading: false });
        setFieldsValue({ installmentCount: 1 });
        return;
      }

      const { installments, defaultInstallment } = response.data;
      setAvailableInstallments({ data: installments, loading: false });

      setFieldsValue({ installmentCount: defaultInstallment });
    });
  };

  const getConstantPaymentRequestInfo = () => {
    RequestHandler.post(
      `/ConstantPaymentRequest/GetByPaymentRequestId`,
      {
        PaymentRequestString: props.location.search.split("d=")[1],
      },
      false
    ).then((response) => {
      form.setFieldsValue({
        ...form.getFieldValue(),
        customerInformation: response.firmName,
      });
      setTenantName(response.tenantName);
      setUseAdditionalInformation(response.isPosTransactionUseAdditionalField);
      if (response.confidentialityAgreementPath) {
        setconfidentialAgreement(response.confidentialityAgreementPath);
      }
      if (response.salesAgreementPath) {
        setSalesAgreement(response.salesAgreementPath);
      }
      setIsUseCreditCardBinCheck(response.isUseCreditCardBinCheck);
      if (response.isUseCreditCardBinCheck) {
        setUsePosCommissionTable(true);
        RequestHandler.get(
          `/ConstantPaymentRequest/CommissionOptions?paymentGuid=${
            props.location.search.split("d=")[1]
          }&requestForNoPayment=true`
        ).then((response) => {
          if (response.success) {
            setCommissionOptionsForBinCheckUsage({
              data: response.data,
              loading: false,
            });
          } else {
            setCommissionOptionsForBinCheckUsage({
              ...commissionOptions,
              loading: false,
            });
          }
        });
      }
    });
  };

  const onFinish = (values) => {
    let expireMonth, expireYear;

    if (values.expiration) {
      [expireMonth, expireYear] = values.expiration.split("/");
    }

    var bankIdCommissionIdWithInstallment = values.bankIdInstallment.split("/");
    values.bankId = bankIdCommissionIdWithInstallment[0];
    values.installmentCount = bankIdCommissionIdWithInstallment[3];
    values.cardType = bankIdCommissionIdWithInstallment[2];
    values.posCollectionCommissionDefinitionId =
      bankIdCommissionIdWithInstallment[1];

    if (values.bankId === "1011") {
      setOzanIframe(true);
    }

    RequestHandler.post(
      `/ConstantPaymentRequest/SalesRequest`,
      {
        holderName: values.holderName,
        cardNumber: values.cardNumber,
        cvv: values.cvv,
        expireMonth: expireMonth,
        expireYear: expireYear,
        amount: payableAmount,
        currencyCode: values.currencyCode,
        bankId: values.bankId,
        installmentCount: values.installmentCount,
        mobilePhone: values.MobilePhone,
        description: values.description,
        email: email,
        customerEmail: values.email,
        paymentGuid: paymentGuid,
        firmId: firmId != "" ? firmId : null,
        cardType: values.cardType,
        tckn: values.tckn,
        contractNumber: values.contractNumber,
        branchCode: values.branchCode,
        memberNumber: values.memberNumber,
        netAmount: values.amount,
        posCollectionCommissionDefinitionId:
          values.posCollectionCommissionDefinitionId,
      },
      false
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        //fill html
        setPaymentModal({ visible: true, source: response.data.html });
        setPosCollectionTransactionId(response.data.posCollectionTransactionId);
        if (!isPaymentWithParams) {
          form.resetFields();
        }

        setFieldsValue({
          bankId: values.bankId,
        });

        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onChangeActiveProvider = (value) => {
    setActiveProviderId(value);
  };

  const onFinishFailed = () => {
    setLoading(false);
  };

  const onChangeRadio = (radioVal, values) => {
    setRadioValue(radioVal);
    setFieldsValue(values);
  };

  const setFieldsValue = (values) => {
    const currentValues = form.getFieldsValue();
    const newValues = { ...currentValues, ...values };
    form.setFieldsValue(newValues);

    onFormValuesChange(values, newValues);
  };

  const onFormValuesChange = (changedValues, allValues) => {
    var activeCommissions = commissionOptions.data.commissions.find(
      (x) => x.bankId === allValues.bankId
    );

    var installmentCount = allValues.installmentCount;
    if (allValues.bankIdInstallment) {
      var bankIdCommissionIdWithInstallment =
        allValues.bankIdInstallment.split("/");

      activeCommissions = commissionOptions.data.commissions.find(
        (x) => x.id === bankIdCommissionIdWithInstallment[1]
      );
      installmentCount = bankIdCommissionIdWithInstallment[3];
    }

    if (!activeCommissions) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );

      setActiveCommissionRate(0);
      return;
    }
    const commissionRate =
      activeCommissions["commissionRate" + installmentCount];
    if (!(allValues.amount > 0 && commissionRate >= 0)) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );
      setActiveCommissionRate(commissionRate);
      return;
    }

    setPayableAmount(
      calculatePayableAmount(
        allValues.amount,
        commissionRate,
        allValues.bankId,
        activeCommissions["isCommissionFromDealer"]
      )
    );
    setActiveCommissionRate(commissionRate);
  };

  const calculatePayableAmount = (
    amount,
    commissionRate,
    bankId,
    isCommissionFromDealer
  ) => {
    const { useCommissionsForAvailableInstallment } = commissionOptions.data;
    let payableAmount = amount;
    if (useCommissionsForAvailableInstallment) {
      payableAmount = amount + (amount / 100) * commissionRate;
    }

    if (isCommissionFromDealer && useCommissionsForAvailableInstallment) {
      payableAmount = (amount / (100 - commissionRate)) * 100;
    }

    if (bankId == 856) {
      payableAmount = amount / ((100 - commissionRate) / 100);
    }

    return payableAmount;
  };

  const isExternalPaymentFormProvider = false;

  const afterPayment = () => {};

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const handleAmountInputBlur = (e) => {
    if (!(isUseCreditCardBinCheck && bankIdFromBinCheckResult === null)) {
      getCommissionOptions(
        paymentGuid,
        bankIdFromBinCheckResult,
        cardKindFromBinCheckResult,
        activeAmount
      );
    }
  };

  const handleCardNumberChange = (e) => {
    if (!isUseCreditCardBinCheck) {
      return;
    }

    const inputValue = e.target.rawValue;

    if (inputValue.length <= 6) {
      setRequestBin(true);
    }

    if ((inputValue.length === 6 || inputValue.length === 16) && requestBin) {
      RequestHandler.post(
        `/PosCollection/CreditCardBinCheck`,
        {
          cardNumber: inputValue,
        },
        false
      ).then((response) => {
        if (response?.success) {
          setRequestBin(false);
          setBankIdFromBinCheckResult(response.data.bankId);
          setCardKindFromBinCheckResult(response.data.cardKind);
          getCommissionOptions(
            paymentGuid,
            response.data.bankId,
            response.data.cardKind,
            form.getFieldValue("amount")
          );
        } else {
          getCommissionOptions();
        }
      });
    }
  };

  useEffect(() => {
    if (isNaN(payableAmount)) {
      setPayableAmount(0);
    } else {
      setPayableAmount(payableAmount);
    }
  }, [payableAmount]);

  useEffect(() => {
    if (availableProviders.data.length > 0) {
      const initialValue = availableProviders.data[0].id;
      onChangeActiveProvider(initialValue);
      setFieldsValue({ bankId: initialValue });
    }
  }, [availableProviders]);

  return (
    <>
      <Row
        id="paymentArea"
        justify="center"
        align="middle"
        style={{
          paddingRight: "50px",
          paddingLeft: "50px",
          paddingTop: "50px",
        }}
      >
        <Col span={24}>
          <Card
            className="gx-card"
            loading={availableProviders.loading || commissionOptions.loading}
          >
            {availableProviders.data.length > 0 ? (
              <Form
                {...formItemLayout}
                validateMessages={defaultValidateMessages}
                form={form}
                name="PaymentForm"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                labelAlign="left"
                onValuesChange={onFormValuesChange}
                fields={[{ name: "payableAmount", value: payableAmount }]}
              >
                <>
                  <div style={{ textAlign: "center" }}>
                    Ödemeyi Alan: <strong>{tenantName}</strong>
                  </div>

                  <Divider>Ödeme Bilgileri</Divider>

                  <Row justify="center">
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Tutar"
                        name="amount"
                        rules={[{ required: true }]}
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          decimalSeparator=","
                          precision={2}
                          min={0}
                          placeholder="0,00"
                          onChange={(value) => setActiveAmount(value)}
                          disabled={disabledAmount}
                          onBlur={handleAmountInputBlur}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Para Birimi"
                        name="currencyCode"
                        initialValue={currencyCodes[0]}
                      >
                        <Select>
                          {currencyCodes.map((currencyCode) => (
                            <Select.Option
                              key={currencyCode}
                              value={currencyCode}
                            >
                              {currencyCode}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  {isExternalPaymentFormProvider &&
                    commissionOptions.data.posCollectionDescription && (
                      <Row
                        id="descriptionArea"
                        style={{ marginBottom: 12 }}
                        justify="center"
                      >
                        <Col xs={24} lg={12}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                commissionOptions.data.posCollectionDescription,
                            }}
                          />
                        </Col>
                      </Row>
                    )}

                  {!isExternalPaymentFormProvider && (
                    <>
                      <Row justify="center">
                        <Col xs={24}>
                          <PosSelectableInstallmentTable
                            data={commissionOptions.data}
                            amount={activeAmount}
                            loading={commissionOptions.loading}
                            onChange={onChangeRadio}
                            radioValue={radioValue}
                          />
                        </Col>
                      </Row>

                      {commissionOptions.data.posCollectionDescription && (
                        <Row
                          id="descriptionArea"
                          style={{ marginBottom: 12 }}
                          justify="center"
                        >
                          <Col xs={24} lg={12}>
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  commissionOptions.data
                                    .posCollectionDescription,
                              }}
                            />
                          </Col>
                        </Row>
                      )}

                      <Divider>Kart Bilgileri</Divider>

                      <Row justify="center">
                        <Col xs={24} lg={12}>
                          <Form.Item
                            label="Kart Üzerindeki İsim"
                            name="holderName"
                            rules={[{ required: true }]}
                          >
                            <Input placeholder="Ad Soyad" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row justify="center">
                        <Col xs={24} lg={12}>
                          <Form.Item
                            label="Kart Numarası"
                            name="cardNumber"
                            valuePropName="rawValue"
                            rules={[{ required: true }]}
                          >
                            <Cleave
                              className="ant-input"
                              placeholder="0000 0000 0000 0000"
                              options={{
                                creditCard: true,
                                onCreditCardTypeChanged: (type) =>
                                  setCreditCardType(type),
                              }}
                              onChange={handleCardNumberChange}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row justify="center">
                        <Col xs={24} lg={6}>
                          <Form.Item
                            label="Son Kullanma Tarihi"
                            name="expiration"
                            rules={[{ required: true }]}
                          >
                            <Cleave
                              className="ant-input"
                              placeholder="AA/YY"
                              options={{
                                date: true,
                                datePattern: ["m", "y"],
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} lg={6}>
                          <Form.Item
                            label="Güvenlik Kodu"
                            name="cvv"
                            rules={[{ required: true }]}
                          >
                            <Cleave
                              className="ant-input"
                              placeholder="CVV"
                              options={{
                                blocks: [4],
                                numericOnly: true,
                              }}
                              type="password"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                </>

                <Divider>Müşteri Bilgileri</Divider>

                <Row justify="center">
                  <Col xs={24} lg={6}>
                    <Form.Item
                      label="Müşteri Bilgisi"
                      name="customerInformation"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Müşteri Bilgisi" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={6}>
                    <Form.Item
                      label="Cep Numarası"
                      name="MobilePhone"
                      rules={[
                        {
                          required: true,
                          min: 12,
                          message: "Telefon numarasını eksiksiz giriniz.",
                        },
                      ]}
                    >
                      <PhoneInput
                        inputStyle={{ width: "100%" }}
                        country="tr"
                        masks={{ tr: "(...) ...-..-.." }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {useAdditionalInformation && (
                  <>
                    <Row justify="center">
                      <Col xs={9} lg={6}>
                        <Form.Item
                          label="TC Kimlik Numarası"
                          name="tckn"
                          rules={[
                            {
                              required: true,
                              min: 11,
                              message:
                                "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                            },
                          ]}
                        >
                          <Input
                            placeholder="TC Kimlik Numarası"
                            type="number"
                            onKeyDown={(evt) =>
                              evt.key === "e" && evt.preventDefault()
                            }
                            maxLength="11"
                            onInput={maxLengthCheck}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={15} lg={6}>
                        <Form.Item
                          label="Sözleşme Numarası"
                          name="contractNumber"
                          rules={[
                            {
                              required: true,
                              message: "Sözleşme numarası boş bırakılamaz.",
                            },
                          ]}
                        >
                          <Input placeholder="Sözleşme Numarası" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify="center">
                      <Col xs={15} lg={6}>
                        <Form.Item label="Şube Adı/Kodu" name="branchCode">
                          <Input placeholder="Şube Adı/Kodu" />
                        </Form.Item>
                      </Col>
                      <Col xs={9} lg={6}>
                        <Form.Item label="Ek Alan" name="memberNumber">
                          <Input placeholder="Ek Alan" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                <Row justify="center">
                  <Col xs={24} lg={6}>
                    <Form.Item
                      label="Email"
                      name="email"
                      hidden={isPaymentWithParams}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={6}>
                    <Form.Item
                      label="Açıklama"
                      name="description"
                      rules={[{ required: isPaymentWithParams ? false : true }]}
                      hidden={isPaymentWithParams}
                    >
                      <TextArea rows={4} />
                    </Form.Item>
                  </Col>
                </Row>

                <PosCollectionAmountSummary
                  payableAmount={payableAmount}
                  activeAmount={activeAmount}
                  commissionRate={activeCommissionRate}
                />

                <Row justify="center">
                  <Col xs={24} lg={8}>
                    <Form.Item
                      name="agreement"
                      valuePropName="checked"
                      rules={[
                        {
                          required: true,
                          message: "Sözleşmeleri kabul etmeniz gerekmektedir.",
                        },
                      ]}
                    >
                      <Checkbox>
                        <a href={confidentialAgreement} target="_blank">
                          Gizlilik
                        </a>{" "}
                        ve{" "}
                        <a href={salesAgreement} target="_blank">
                          Tüketici Hakları
                        </a>{" "}
                        sözleşmelerini okudum, onaylıyorum.
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={4} style={{ textAlign: "right" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={() => setLoading(true)}
                      loading={loading}
                    >
                      {payableAmount > 0
                        ? `(${ColumnHelper.renderDecimal(payableAmount)}) `
                        : undefined}
                      Öde
                    </Button>
                  </Col>
                </Row>
              </Form>
            ) : (
              "Firmanızın tanımlı bir ödeme sağlayıcısı bulunmuyor."
            )}
          </Card>
          {!usePosCommissionTable &&
            !commissionOptions.loading &&
            !commissionOptions.data.isSelectableInstallmentTable &&
            commissionOptions.data.commissions.length > 0 && (
              <PosCommissionTable
                data={commissionOptions.data}
                amount={activeAmount}
                loading={commissionOptions.loading}
              />
            )}

          {usePosCommissionTable && (
            <PosCommissionTable
              data={commissionOptionsForBinCheckUsage.data}
              amount={activeAmount}
              loading={commissionOptionsForBinCheckUsage.loading}
            />
          )}
          <Footer>
            <div className="gx-layout-footer-content">
              {Screen.screen === 0 ? (
                <>
                  <span>{footerText}</span>
                  <img
                    src={require("../assets/images/paymentSymbols.png")}
                    alt="PaymentSymbols"
                    title="PaymentSymbols"
                    style={{
                      width: "100%",
                      maxWidth: "450px",
                      marginLeft: "500px",
                    }}
                  />
                </>
              ) : null}
            </div>
          </Footer>
        </Col>
      </Row>

      <Modal
        id="paymentModal"
        centered
        visible={paymentModal.visible}
        onCancel={() => {
          if (isPaymentWithParams) {
            afterPayment();
          }
          setPaymentModal({ ...paymentModal, visible: false });
        }}
        destroyOnClose={false}
        maskClosable={false}
        keyboard={false}
        width={600}
        footer={null}
      >
        {ozanIframe ? (
          <iframe
            id="paymentFrame"
            ref={iframeRef}
            style={{ width: "100%", border: 0 }}
            src={paymentModal.source}
            scrolling="auto"
            onLoad={() => {
              const iframe = iframeRef.current;
              iframe.style.height = iframe.scrollWidth + 150 + "px";
            }}
          />
        ) : (
          <iframe
            id="paymentFrame"
            ref={iframeRef}
            style={{ width: "100%", border: 0 }}
            srcDoc={paymentModal.source}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
            scrolling="auto"
            onLoad={() => {
              const iframe = iframeRef.current;
              iframe.style.height = iframe.scrollWidth + 150 + "px";
            }}
          />
        )}
      </Modal>
    </>
  );
};
export default ConstantPaymentPage;
